import React, { forwardRef, useRef } from 'react';
import './CoachMessageInput.css';

// Share the exact action between the keyboard and button, including the gap
// before React has committed its busy state.
export function useCoachComposerSubmit(action, disabled = false) {
  const pending = useRef(false);
  return async () => {
    if (disabled || pending.current) return;
    pending.current = true;
    try {
      await action();
    } finally {
      pending.current = false;
    }
  };
}

const CoachMessageInput = forwardRef(function CoachMessageInput({ onSend, ...props }, ref) {
  return <textarea {...props} ref={ref} rows={2} onKeyDown={event => {
    if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229) return;
    event.preventDefault();
    if (!event.repeat && !props.disabled) onSend();
  }} />;
});

export default CoachMessageInput;
